import { FC } from 'react';
import { useIntercom } from 'react-use-intercom';
import { Link } from '@chakra-ui/react';

import Callout from 'components/_core/Callout';
import Text from 'components/_core/Text';

import locales from './locales';

const VerifyInformationCallout: FC = () => {
  const intercom = useIntercom();
  return (
    <Callout>
      <Callout.Content>
        <Text size="sm">
          {locales.callout}
          <Link onClick={() => intercom.showNewMessages()} size="sm">
            {locales.contactUs}
          </Link>
          .
        </Text>
      </Callout.Content>
    </Callout>
  );
};

export default VerifyInformationCallout;
